const MuiTab = {
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
  },
};

export default MuiTab;
